import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JwtintercepterService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = localStorage.getItem("EmployeeData") !== null ? JSON.parse(localStorage.getItem("EmployeeData"))["Token"].data : 1;
    // console.log(token);
    req = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token
      }
    })

    return next.handle(req)
    // .pipe(
    //   catchError((error : HttpErrorResponse) =>
    //   {
    //     if(error instanceof HttpErrorResponse && error.status === 401){
    //       //router.navigate();
    //     }
    //   })
    // );
  }
}
